var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8203 0.96875C10.4862 0.96875 9.30219 1.52633 8.5 2.48469C7.69781 1.52633 6.51379 0.96875 5.17969 0.96875C4.01772 0.970239 2.90376 1.45964 2.08212 2.3296C1.26049 3.19957 0.798281 4.37906 0.796875 5.60938C0.796875 10.6958 7.82332 14.7598 8.12215 14.9307C8.23827 14.9969 8.36811 15.0316 8.5 15.0316C8.63189 15.0316 8.76173 14.9969 8.87785 14.9307C9.17668 14.7598 16.2031 10.6958 16.2031 5.60938C16.2017 4.37906 15.7395 3.19957 14.9179 2.3296C14.0962 1.45964 12.9823 0.970239 11.8203 0.96875Z",
    fill: "#E9A5F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.ddde5d82915010a9081470dcb8387186.svg";
export { ForwardRef as ReactComponent };